export const returnMonthlySearchesTimeFrames = (fromDate, toDate) => {
  const monthlySearches = [];

  let startDate = fromDate.clone();

  while (
    startDate.isBefore(toDate, 'month') ||
    startDate.isSame(toDate, 'month')
  ) {
    const isLastMonth = startDate.isSame(toDate, 'month');

    monthlySearches.push({
      fromDate: startDate.startOf('month').toISOString(),
      toDate: isLastMonth
        ? toDate.toISOString()
        : startDate.endOf('month').toISOString(),
    });

    startDate = startDate.add(1, 'month');
  }

  return monthlySearches;
};
